import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";
import "./OneEyedCoconutDetails.css";

const CATEGORY_KEY = "one-eyed-coconut";
const DEFAULT_HEADING = "Ekakshi / One-Eyed Coconut";

function OneEyedCoconutDetails() {
  const [categoryContent, setCategoryContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCategoryContent = async () => {
      try {
        const response = await axios.get(`${API_BASE}/category-content/${CATEGORY_KEY}`);

        if (isMounted) {
          setCategoryContent(response.data || null);
        }
      } catch (error) {
        console.error("Failed to load one-eyed coconut details:", error);

        if (isMounted) {
          setCategoryContent(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchCategoryContent();

    return () => {
      isMounted = false;
    };
  }, []);

  const pageHeading =
    String(categoryContent?.pageHeading || "").trim() || DEFAULT_HEADING;
  const subheading = String(categoryContent?.subheading || "").trim();
  const mainDescription = String(categoryContent?.mainDescription || "").trim();
  const readMoreContent = String(categoryContent?.readMoreContent || "").trim();
  const benefits = Array.isArray(categoryContent?.benefits) ? categoryContent.benefits.filter(Boolean) : [];
  const benefitsTitle = String(categoryContent?.benefitsTitle || "").trim() || "Benefits";
  const whyTitle = String(categoryContent?.whyTitle || "").trim() || "Why One Eyed Coconut";
  const whyDescription = String(categoryContent?.whyDescription || "").trim();
  const images = Array.isArray(categoryContent?.images) ? categoryContent.images.filter((image) => image?.url) : [];
  const note = String(categoryContent?.note || "").trim();

  return (
    <div className="one-eyed-details-page">
      <section className="one-eyed-details-card">
        <h1>{pageHeading}</h1>
        {subheading ? <p className="one-eyed-details-subheading">{subheading}</p> : null}

        {isLoading ? (
          <p className="one-eyed-details-loading">Loading content...</p>
        ) : (
          <>
            {images.length > 0 ? (
              <div className="one-eyed-details-gallery">
                {images.map((image, index) => (
                  <img src={image.url} alt={image.alt || pageHeading} key={`${image.url}-${index}`} />
                ))}
              </div>
            ) : null}

            {mainDescription ? (
              <p className="one-eyed-details-description">{mainDescription}</p>
            ) : null}

            {readMoreContent ? (
              <p className="one-eyed-details-description">{readMoreContent}</p>
            ) : null}

            {benefits.length > 0 ? (
              <div className="one-eyed-details-section">
                <h2>{benefitsTitle}</h2>
                <ul>
                  {benefits.map((benefit, index) => (
                    <li key={`${benefit}-${index}`}>{benefit}</li>
                  ))}
                </ul>
              </div>
            ) : null}

            {whyDescription ? (
              <div className="one-eyed-details-section">
                <h2>{whyTitle}</h2>
                <p>{whyDescription}</p>
              </div>
            ) : null}

            {note ? (
              <div className="one-eyed-details-note">
                <strong>Note:</strong>
                <p>{note}</p>
              </div>
            ) : null}
          </>
        )}
      </section>
    </div>
  );
}

export default OneEyedCoconutDetails;
